import { Businesses, Routes } from '@just-in-types';
import { navigate, NavigateFn } from '@reach/router';
import { Reducer } from 'redux';
import {
  SET_ACTIVE_BUSINESS,
  SET_ACTIVE_SITE,
  SET_ALLOW_OPT_OUT,
  SET_BUSINESS_ID,
  SET_BUSINESS_PATH,
  SET_GUID,
  SET_LANGUAGE,
  SET_OPT_IN_FIELD,
  SET_ROOT_PATH,
  SET_ROUTES,
  SET_ROUTES_OBJECT,
  SET_ROUTES_STRINGS,
  SET_SHOW_COUPONS,
} from '../actions';
import { IStrings, strings } from './strings';

export interface IRouterState {
  allowOptOut: boolean;
  businesses: Businesses.Business[];
  businessId?: string;
  businessPath?: string;
  guid?: string;
  languageStrings: IStrings;
  navigate: NavigateFn;
  noCheckIn?: boolean;
  optInField?: boolean;
  rootPath?: string;
  routeStrings: Routes.RouteString[];
  routes: null | Routes.RoutesObject;
  showCoupons: boolean;
  siteId?: string;
  sitePath?: string;
  business?: any;
}

const routerInitialState: IRouterState = {
  allowOptOut: false,
  businesses: [],
  languageStrings: strings.eng,
  navigate,
  optInField: true,
  routeStrings: ['mobile'],
  routes: null,
  showCoupons: false,
};

const routerReducer: Reducer = (
  state = routerInitialState,
  { type, payload },
): IRouterState => {
  switch (type) {
    case SET_ALLOW_OPT_OUT:
      return { ...state, allowOptOut: payload };

    case SET_BUSINESS_ID: {
      const { businessId } = payload;

      return { ...state, businessId };
    }

    case SET_GUID: {
      const { guid } = payload;

      return { ...state, guid };
    }

    case SET_BUSINESS_PATH:
      return { ...state, businessPath: payload };

    case SET_LANGUAGE:
      return { ...state, languageStrings: strings[payload] };

    case SET_ROOT_PATH:
      return { ...state, rootPath: payload };

    case SET_ROUTES: {
      const businesses = state.businesses;
      const newBusinessId = payload.businessId;

      if (
        !businesses.some(
          ({ businessId }: { businessId: string }) =>
            businessId === newBusinessId,
        )
      ) {
        businesses.push(payload);
      }

      return { ...state, businesses };
    }

    case SET_ROUTES_OBJECT:
      return { ...state, routes: payload, routesType: 'object' };

    case SET_ROUTES_STRINGS:
      return { ...state, routeStrings: payload };

    case SET_SHOW_COUPONS:
      return { ...state, showCoupons: payload };

    case SET_ACTIVE_SITE: {
      return {
        ...state,
        noCheckIn: payload.noCheckIn,
        siteId: payload.siteId,
        sitePath: payload.path,
      };
    }

    case SET_ACTIVE_BUSINESS: {
      return { ...state, business: payload };
    }

    case SET_OPT_IN_FIELD: {
      return { ...state, optInField: payload}
    }

    default:
      return { ...state };
  }
};

export default routerReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/routerReducer.ts